<template>
    <section class="main-section main-section--num bg-gray-f5">
        <div class="container">
            <div class="mb-60 mb-md-30 ">
                <div class="tit-wrap">
                    <h3 class="text-40 text-lg-30 text-md-24 font-weight-regular">e이음은 <strong>여러분의 많은 참여를 기다립니다.</strong></h3>
                </div>
            </div>
            <div>
                <div class="icon-num-items">
                    <div class="icon-num-item" v-for="({ text, value, unit, icon }, i) in items" :key="`summary-item-${i}`">
                        <div class="icon-num-item__icon" :style="`background-image:url(${icon});`"></div>
                        <div class="icon-num-item__tit text-18 text-md-16">{{ text }}</div>
                        <div class="icon-num-item__num">
                            <strong class="color-primary">{{ value }}</strong
                            ><small>{{ unit }}</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import api from "@/api";
export default {
    computed: {
        items() {
            const { organizations, supporters, requests, responses } = this.summary || {};

            return [
                { text: "참여기업", value: organizations, unit: "개", icon: "/images/icon/icon-building.png" },
                { text: "전문제조지원단", value: supporters, unit: "명", icon: "/images/icon/icon-people.png" },
                { text: "자문의뢰", value: requests, unit: "건", icon: "/images/icon/icon-request.png" },
                { text: "전문가답변", value: responses, unit: "건", icon: "/images/icon/icon-answer.png" },
            ];
        },
    },
    data() {
        return {
            summary: {
                organizations: 512,
                supporters: 201,
                requests: 317,
                responses: 455,
            },
        };
    },
    methods: {
        async search() {
            var { summary: users = [] } = (await api.v1.users.summary.get()) || {};
            var { summary: counsels = [] } = (await api.v1.counsels.summary.get()) || {};

            this.summary = {
                ...(this.summary || {}),
                ...(users || {}),
                ...(counsels || {}),
            };
        },
    },
    mounted() {
        this.search();
    },
};
</script>

<style></style>
